<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'DebtorList' }" class="nav-link">Dłużnicy</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}</div>

			<DebtorForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></DebtorForm>
		</div>
	</b-container>
</template>

<script>
  import DebtorForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('debtor/update/retrieve', this.$route.params.id);
    },
    components: {
      DebtorForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'debtor/update/retrieveError',
        retrieveLoading: 'debtor/update/retrieveLoading',
        updateError: 'debtor/update/updateError',
        updateLoading: 'debtor/update/updateLoading',
        deleteError: 'debtor/del/error',
        deleteLoading: 'debtor/del/loading',
        created: 'debtor/create/created',
        deleted: 'debtor/del/deleted',
        retrieved: 'debtor/update/retrieved',
        updated: 'debtor/update/updated',
        violations: 'debtor/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('debtor/update/update', {item: this.retrieved, values: values });
        this.$store.dispatch('debtor/create/reset');
      },
      del () {
        if (window.confirm('Czy na pewno chce usunąć tego dłużnika?'))
          this.$store.dispatch('debtor/del/delete', this.retrieved);
		  this.$store.dispatch('debtor/create/reset');
      },
      reset () {
        this.$store.dispatch('debtor/update/reset');
        this.$store.dispatch('debtor/del/reset');
        this.$store.dispatch('debtor/create/reset');

      }
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'DebtorList' });
        }
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?574d7be2